import React from "react";

import "../styles/firstLoader.css";

export const FirstLoader = () => {
  return (
    <>
      <div className="f__loader" id="loading">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </>
  );
};
